type VanityInput = string | Array<string | { value: string }> | null | undefined

/**
 * The vanity values a scoped Typesense key is filtered by: plain strings or the
 * `{ value }` of target-job-shop options, empty ones dropped, de-duplicated and
 * sorted. Shared by searchAndFiltersRepository.getTypesenseApiKey (the request)
 * and typesenseApiKeyCacheKey (its cache entry), so callers sharing a cache
 * entry always send the identical filter, whichever of them fetches first.
 */
export function normalizeVanities(vanity: VanityInput): string[] {
  const items = Array.isArray(vanity) ? vanity : [vanity]
  const values = items
    .map(item => (typeof item === "string" ? item : item?.value))
    .filter((value): value is string => !!value)
  return [...new Set(values)].sort()
}

/**
 * The useAsyncData key for a scoped Typesense API key. Built from the normalised
 * vanity filter, so every caller asking for the same filter shares one
 * /search/api-key request per render — regardless of value order, duplicates,
 * or whether the target list is just the shop's own vanity.
 */
export function typesenseApiKeyCacheKey(jobShopId: string, headerVanity?: string, targetJobShops?: VanityInput): string {
  const baseKey = `typesenseApiKey-${jobShopId}`
  const vanities = normalizeVanities(targetJobShops)

  if (vanities.length === 0 || (vanities.length === 1 && vanities[0] === headerVanity))
    return baseKey

  return `${baseKey}-${vanities.join("-")}`
}
